import { useAuth } from '@/hooks/useAuth';
import type { ActiveMembership } from '@/lib/types/auth.types';

/**
 * The active entity for the current session, reflected from `activeMembership`
 * (see ADR FE-1). Persona workspace pages pass this to their feature so the
 * feature resolves the right typed module from the registry. Returns `null`
 * for individuals / super admins (no acting entity).
 */
export function useEntity(): ActiveMembership | null {
  return useAuth().user?.activeMembership ?? null;
}
